import script from "./transfer-execute-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./transfer-execute-modal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__